import React from "react";
import { useTranslation } from "react-i18next";
import AppCheckbox from "components/ui/AppCheckbox";
import AppPaginatedTable from "components/ui/AppPaginatedTable";
import { AED } from "features/order-taking/pages/take-order/components/icons";

const ModifiersTable = ({
  showAttachButton = true,
  showActionButton = true,
  modifiers,
  selectedModifiers,
  toBeUnLinkModifiers = [],
  actionButtons = () => {},
  setSelectedModifiers = () => {},
  setToBeUnLinkModifiers = () => {},
  height = "70vh",
}) => {
  const { t } = useTranslation();

  const handleSelectAllModifiers = () => {
    if (selectedModifiers?.length === modifiers?.length) {
      setSelectedModifiers([]);
      setToBeUnLinkModifiers(modifiers);
    } else {
      setSelectedModifiers(modifiers);
      setToBeUnLinkModifiers([]);
    }
  };

  const handleSelectModifier = (modifier) => {
    if (selectedModifiers?.some((row) => row._id === modifier?._id)) {
      setSelectedModifiers(
        selectedModifiers.filter((row) => row._id !== modifier?._id)
      );
      if(!toBeUnLinkModifiers?.some((row) => row._id === modifier?._id)) {
        setToBeUnLinkModifiers(prevState => [...prevState, modifier]);
      }
    } else {
      setSelectedModifiers([...selectedModifiers, modifier]);
      setToBeUnLinkModifiers(prevState => prevState.filter(m => m._id !== modifier._id));
    }
  };

  const columns = [];
  if (showAttachButton) {
    columns.push({
      title: (
        <div>
          <AppCheckbox
            label={`${selectedModifiers?.length} / ${modifiers?.length}`}
            checked={selectedModifiers?.length === modifiers?.length}
            onChange={() => handleSelectAllModifiers()}
          />
        </div>
      ),
      dataIndex: "_id",
      align: "center",
      render: (value, row, i) => {
        return (
          <AppCheckbox
            checked={
              selectedModifiers.find((modifier) => modifier._id === row?._id)
                ? true
                : false
            }
            onChange={() => handleSelectModifier(row)}
          />
        );
      },
    });
  }

  columns.push(
    ...[
      {
        title: t("Name"),
        dataIndex: "baseLanguage",
        key: "title",
        render: (value, row, i) => {
          return <div className="truncate-line-3">{value?.name}</div>;
        },
      },
      {
        title: t("Maximum Order Quantity"),
        dataIndex: "maximumOrderQuantity",
        width: "100px",
        headerStyle: { whiteSpace: "break-spaces" },
        render: (value, row, i) => {
          return <div className="text-center w-full">{value}</div>;
        },
      },
      {
        title: t("Price"),
        dataIndex: "price",
        headerClassName: "text-center",
        render: (value, row, i) => {
          return (
            <div className="flex items-center gap-1 text-center w-full justify-center text-16px">
              <AED width={16} height={16} /> <span>{value}</span>
            </div>
          );
        },
      },
    ]
  );

  if (showActionButton) {
    columns.push(
      ...[
        {
          title: t("Action"),
          fixed: "right",
          render:  actionButtons,
        },
      ]
    );
  }

  return (
    <div
      style={{ height: height }}
    >
      <AppPaginatedTable
        columns={columns}
        data={modifiers}
        clientSidePagination={true}
        pageSize={10}
        total={modifiers?.length}
      />
    </div>
  );
};

export default ModifiersTable;
